"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiFactorAuthApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class MultiFactorAuthApi extends runtime.BaseAPI {
    /**
     * Issue an authentication challenge
     */
    async challengeRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling challenge.');
        }
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling challenge.');
        }
        if (requestParameters.mfaChallenge === null || requestParameters.mfaChallenge === undefined) {
            throw new runtime.RequiredError('mfaChallenge', 'Required parameter requestParameters.mfaChallenge was null or undefined when calling challenge.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/mfa/challenge/{enrollmentId}`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.MfaChallengeToJSON(requestParameters.mfaChallenge),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MfaTokenFromJSON(jsonValue));
    }
    /**
     * Issue an authentication challenge
     */
    async challenge(requestParameters) {
        const response = await this.challengeRaw(requestParameters);
        return await response.value();
    }
    /**
     * Determine which types of MFA a member is allowed to use
     */
    async channelsRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling channels.');
        }
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling channels.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/mfa/{enrollmentId}/channels`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MfaChannelsFromJSON(jsonValue));
    }
    /**
     * Determine which types of MFA a member is allowed to use
     */
    async channels(requestParameters) {
        const response = await this.channelsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Respond to an authentication challenge
     */
    async verifyRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling verify.');
        }
        if (requestParameters.mfaVerify === null || requestParameters.mfaVerify === undefined) {
            throw new runtime.RequiredError('mfaVerify', 'Required parameter requestParameters.mfaVerify was null or undefined when calling verify.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/mfa/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.MfaVerifyToJSON(requestParameters.mfaVerify),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AuthTokenFromJSON(jsonValue));
    }
    /**
     * Respond to an authentication challenge
     */
    async verify(requestParameters) {
        const response = await this.verifyRaw(requestParameters);
        return await response.value();
    }
}
exports.MultiFactorAuthApi = MultiFactorAuthApi;
//# sourceMappingURL=MultiFactorAuthApi.js.map